"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BlockText = BlockText;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var _recoil = require("recoil");

var _RecoilStates = require("../../contexts/RecoilStates");

var __jsx = _react["default"].createElement;

/**
 * @param {{block: import("../../../types/blocks").BlockText}} param0
 */
function BlockText(_ref) {
  var _block$content$intl$l, _block$content$intl$l2, _block$content$intl$d;

  var block = _ref.block;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var text = (_block$content$intl$l = (_block$content$intl$l2 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l2.text) != null ? _block$content$intl$l : (_block$content$intl$d = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d.text;
  return __jsx(_react2.Box, {
    className: "renderer",
    color: "rgba(0,0,0,.87)",
    dangerouslySetInnerHTML: {
      __html: text.replace(/(<([^>]+)>)/gi, "").replace("\n", "").length > 0 ? text : "Ajoutez votre texte"
    }
  });
}